import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Categories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const authtoken = localStorage.getItem("token");
        const authToken = `Bearer ${authtoken}`;

        const category = await getCategories(authToken);
        setCategories(category.categories);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="container mt-5 p-3 page-section">
      <div className="row p-4 minHight">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="mb-4">All Categories</h4>
        </div>
        <div className="row mt-3">
          {categories.map((category) => (
            <div
              key={category.id}
              className="col-lg-2 col-md-4 col-6 mb-lg-4 mb-md-3 mb-3"
            >
              <Link
                to={`/category/${category.name}`}
                className="card bordercolor py-3 px-4 shadow nav-link rounded-5"
              >
                {category.name}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Categories;

export const getCategories = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}product/categories`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};
